var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowDownSimple = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.805 6.529a.667.667 0 0 0-.943 0L8 8.39 6.138 6.529a.667.667 0 0 0-.943.942L7.53 9.805c.26.26.682.26.942 0l2.334-2.334a.667.667 0 0 0 0-.942Z",
  fill: "#777E91"
})));
export default SvgArrowDownSimple;